import type { HandleConfig } from './types';

export const HANDLE_SIZE = 8;
export const CORNER_SIZE = 14;

export const ResizeDirections = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
} as const;

export const HANDLES: HandleConfig[] = [
  {
    direction: ResizeDirections.TOP,
    cursor: 'ns-resize',
    sx: { top: 0, left: CORNER_SIZE, right: CORNER_SIZE, height: HANDLE_SIZE },
  },
  {
    direction: ResizeDirections.BOTTOM,
    cursor: 'ns-resize',
    sx: { bottom: 0, left: CORNER_SIZE, right: CORNER_SIZE, height: HANDLE_SIZE },
  },
  {
    direction: ResizeDirections.LEFT,
    cursor: 'ew-resize',
    sx: { left: 0, top: CORNER_SIZE, bottom: CORNER_SIZE, width: HANDLE_SIZE, zIndex: 3 },
  },
  {
    direction: ResizeDirections.RIGHT,
    cursor: 'ew-resize',
    sx: { right: 0, top: CORNER_SIZE, bottom: CORNER_SIZE, width: HANDLE_SIZE },
  },
  {
    direction: ResizeDirections.TOP_LEFT,
    cursor: 'nwse-resize',
    sx: { top: 0, left: 0, width: CORNER_SIZE, height: CORNER_SIZE, zIndex: 3 },
  },
  {
    direction: ResizeDirections.TOP_RIGHT,
    cursor: 'nesw-resize',
    sx: { top: 0, right: 0, width: CORNER_SIZE, height: CORNER_SIZE, zIndex: 1 },
  },
  {
    direction: ResizeDirections.BOTTOM_LEFT,
    cursor: 'nesw-resize',
    sx: { bottom: 0, left: 0, width: CORNER_SIZE, height: CORNER_SIZE, zIndex: 3 },
  },
  {
    direction: ResizeDirections.BOTTOM_RIGHT,
    cursor: 'nwse-resize',
    sx: { bottom: 0, right: 0, width: CORNER_SIZE, height: CORNER_SIZE, zIndex: 1 },
  },
];

export const DEFAULT_WIDTH = 600;
export const DEFAULT_HEIGHT = 700;
export const DEFAULT_MIN_WIDTH = 600;
export const DEFAULT_MIN_HEIGHT = 700;
export const VIEWPORT_MARGIN = 24;

export const CHAT_MIN_WIDTH = 600;
export const SIDE_PANEL_MIN_WIDTH = 900;
export const MODAL_WITH_SIDE_PANEL_MIN_WIDTH = CHAT_MIN_WIDTH + SIDE_PANEL_MIN_WIDTH;

export const WINDOW_RESIZE_DEBOUNCE_MS = 100;
